export namespace E2e {
  export const DataAttribute = 'data-e2e';
  export const Selector = (type: string): string =>
    `[${DataAttribute}=${type}]`;

  export const SelectorStartWith = (type: string): string =>
    `[${DataAttribute}^=${type}]`;

  export enum TripType {
    SingleTrip = 'single-trip',
    AnnualMultiTrip = 'annual-multi-trip',
  }
}
